import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaHandshake, 
  FaTools, 
  FaDollarSign, 
  FaTruck 
} from 'react-icons/fa';
import '../../../assets/css/pianoCards.css';

const PianoCards = () => {
  const cards = [
    {
      icon: <FaHandshake className="card-icon" />,
      title: "Atendimento amigo!",
      content: "São mais de 56 anos de serviços realizados e principalmente amizades conquistadas. Inúmeras recomendações são resultado da satisfação de nossos amigos e clientes."
    },
    {
      icon: <FaTools className="card-icon" />,
      title: "Serviço completo!",
      content: "Desde o orçamento até a entrega, todas etapas da reforma, todas as marcas, todos os modelos, compra e venda. Absolutamente tudo em piano."
    },
    {
      icon: <FaDollarSign className="card-icon" />,
      title: "Preço justo!",
      content: "Filosofia de fidelização de clientes e oficina com mão-de-obra própria garantem o melhor preço do mercado tanto em reforma como em venda."
    },
    {
      icon: <FaTruck className="card-icon" />,
      title: "Transporte especializado!",
      content: "O piano exige conhecimento técnico até mesmo em seu transporte. Retiramos e entregamos com excelência e garantia de quem entende."
    }
  ];

  const cardVariants = {
    offscreen: {
      y: 50,
      opacity: 0
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8
      }
    }
  };

  return (
    <div className="piano-cards-container">
      {cards.map((card, index) => (
        <motion.div
          key={index}
          className="piano-card"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, margin: "-50px" }}
          variants={cardVariants}
          whileHover={{ scale: 1.03 }}
          custom={index}
        >
          {card.icon}
          <h3 className="card-title">{card.title}</h3>
          <p className="card-content">{card.content}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default PianoCards;